"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@canonical/react-components");
require("./LoadingCard.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function LoadingCard(_ref) {
  let {
    height
  } = _ref;
  const cardHeight = height ? `${height}px` : "290px";
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Card, {
    style: {
      height: cardHeight
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "100%",
    height: "100%",
    className: "p-card--placeholder"
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "animation-mask"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "36",
    cy: "36",
    r: "20"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "69.5",
    width: "60%",
    height: "18"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "95",
    width: "25%",
    height: "18"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "153",
    width: "70%",
    height: "16"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "170",
    width: "20%",
    height: "16"
  })))));
}
LoadingCard.propTypes = {
  height: _propTypes.default.number
};
var _default = exports.default = LoadingCard;